import React from 'react';
import { CheckCircle2Icon, LockKeyholeIcon, ShieldCheckIcon, ZapIcon } from 'lucide-react';
import { CountdownTimer } from './CountdownTimer';
const rows = [['100 ore/anno pianificando da zero', '10 min/settimana. Tutto pronto.'], ['Allenamenti improvvisati senza progressione', '120+ drill + 6 volumi per livello'], ['Atleti che migliorano lentamente', 'Progressione logica e misurabile'], ['Genitori che chiedono spiegazioni', 'Schede di valutazione e tracking progressi'], ['Entrare in palestra impreparati', 'Ogni sessione pianificata e pronta all’uso']];
export function FinalCTA() {
  return <section className="border-y-4 border-emerald-400 bg-[#09281d] px-5 py-20" data-id="element-35">
      <div className="mx-auto max-w-3xl text-center" data-id="element-36">
        <h2 className="font-display text-4xl font-bold uppercase leading-none text-white sm:text-6xl" data-id="element-37">
          Smetti di improvvisare.{' '}
          <span className="text-emerald-300" data-id="element-38">
            Inizia ad allenare con un sistema.
          </span>
        </h2>
        <p className="mx-auto mt-6 max-w-xl font-medium leading-relaxed text-slate-300" data-id="element-39">
          Unisciti a centinaia di allenatori che già pianificano la loro
          stagione in meno di 5 minuti.
        </p>
        <p className="mt-5 text-xs font-bold uppercase tracking-[.18em] text-emerald-200" data-id="element-40">
          Sessioni · Drill · Progressioni · Valutazione · Tutto organizzato
        </p>
        <div className="mt-10 overflow-x-auto border border-emerald-300/30 text-left" data-id="element-41">
          <div className="min-w-[580px]" data-id="element-42">
            <div className="grid grid-cols-2 bg-[#10372a] text-center text-[10px] font-bold uppercase tracking-widest" data-id="element-43">
              <p className="p-4 text-slate-300" data-id="element-44">Senza PALLAVOLO PRONTA</p>
              <p className="border-l border-emerald-300/30 p-4 text-emerald-300" data-id="element-45">
                Con PALLAVOLO PRONTA
              </p>
            </div>
            {rows.map(([without, withSystem]) => <div key={without} className="grid grid-cols-2 border-t border-emerald-300/20 text-xs sm:text-sm" data-id="element-46">
                <p className="flex gap-2 p-4 font-medium text-slate-300" data-id="element-47">
                  <span className="text-red-400" data-id="element-48">×</span>
                  {without}
                </p>
                <p className="flex gap-2 border-l border-emerald-300/20 bg-emerald-300/5 p-4 font-semibold text-white" data-id="element-49">
                  <CheckCircle2Icon className="h-4 w-4 shrink-0 text-emerald-300" data-id="element-50" />
                  {withSystem}
                </p>
              </div>)}
          </div>
        </div>
        <div className="my-9" data-id="element-51">
          <CountdownTimer dark data-id="element-52" />
        </div>
        <div className="border-2 border-emerald-400 bg-[#10372a] p-7 text-left" data-id="element-53">
          <p className="text-xs font-bold uppercase tracking-widest text-emerald-300" data-id="element-54">
            Pacchetto completo
          </p>
          <h3 className="mt-2 text-xl font-bold text-white" data-id="element-55">
            PALLAVOLO PRONTA™ — 6 Volumi + 5 Bonus
          </h3>
          <div className="mt-5 flex items-end justify-between" data-id="element-56">
            <div data-id="element-57">
              <p className="text-sm font-bold text-slate-300 line-through" data-id="element-58">
                47€
              </p>
              <p className="font-display text-6xl font-bold leading-none text-white" data-id="element-59">
                19€
              </p>
            </div>
            <p className="bg-emerald-400 px-3 py-2 text-xs font-bold uppercase text-[#09281d]" data-id="element-60">
              Risparmi 28€
            </p>
          </div>
        </div>
        <a href="https://pallavolo-pronta.impultienda.ar/checkout" className="cta-button mt-8 block w-full rounded-2xl px-5 py-5 text-lg font-bold sm:text-xl" data-id="element-61">
          SÌ, VOGLIO LA MIA BIBBIA DELLA PALLAVOLO
        </a>
        <div className="mt-6 flex flex-wrap justify-center gap-x-5 gap-y-2 text-xs font-semibold text-slate-300" data-id="element-62">
          <span className="flex gap-1" data-id="element-63">
            <LockKeyholeIcon className="h-4 w-4 text-emerald-300" data-id="element-64" /> Pagamento
            sicuro
          </span>
          <span className="flex gap-1" data-id="element-65">
            <ZapIcon className="h-4 w-4 text-emerald-300" data-id="element-66" /> Accesso immediato
          </span>
          <span className="flex gap-1" data-id="element-67">
            <ShieldCheckIcon className="h-4 w-4 text-emerald-300" data-id="element-68" /> Garanzia 7
            giorni
          </span>
        </div>
      </div>
    </section>;
}